import React, { useState, useEffect } from 'react';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
    }
    
    return () => {
      document.body.classList.remove('menu-open');
    };
  }, [menuOpen]);

  return (
    <header>
      <img 
        src={process.env.PUBLIC_URL + '/assets/images/bebe.jpg'} 
        alt="InkedBySteff tattoo artist portfolio background" 
        className="logo" 
        id="home" 
      />
      <div className="header-overlay"></div>
      <h1 className="page-name">INKED <br /> BY <br /> STEFF</h1>
      
      <button 
        className="mobile-menu-toggle"
        aria-expanded={menuOpen}
        aria-label="Toggle navigation menu"
        onClick={toggleMenu}
      >
        <span className={menuOpen ? 'active' : ''}></span>
        <span className={menuOpen ? 'active' : ''}></span>
        <span className={menuOpen ? 'active' : ''}></span>
      </button>
      
      <nav className={`dynamic-menu ${menuOpen ? 'menu-open' : ''}`}>
        <ul>
          <li><a href="#home" onClick={closeMenu}>Home</a></li>
          <li><a href="#gallery" onClick={closeMenu}>Gallery</a></li>
          <li><a href="#about" onClick={closeMenu}>About</a></li>
          <li><a href="#contact" onClick={closeMenu}>Contact</a></li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;